import { Card } from '@ui/themed';
import { t } from 'i18next';
import { StaffBadge } from '../../../components/staff-badge';
import type { Customer } from '../types/customer';

export function CustomerAdvancedDetailsCard({ customer }: { customer: Customer }) {
  return (
    <Card initialCollapsed>
      <Card.Header headingLevel="h2" collapsible>
        {t('features:customers.components.customer_advanced_details_card.header')}
        <StaffBadge />
      </Card.Header>
      <Card.Body>
        <pre className="whitespace-pre-wrap font-mono text-sm">
          {JSON.stringify(customer, null, 2)}
        </pre>
      </Card.Body>
    </Card>
  );
}
